import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/NextIntlProviderClient.tsx");
